import React, { useEffect } from "react";
import "./bookmarks.css";
import CloseIcon from "@material-ui/icons/Close";
import { CircularProgress } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";
import { fetchBookmarkFiles } from '../../../../actions/projectActions';
// import Axios from "../../../../config/Axios";
// import { Statecontext } from "../../../../context/DataProvider";
import { useDispatch, useSelector } from 'react-redux';

function Bookmarks({ onSelfClose, onNotifyOpen }) {
  // const state = useContext(Statecontext)[0];
  // useEffect(
  //   () =>
  //     async function fetchData() {
  //       await Axios.get("/user/workspaces", {
  //         headers: {
  //           Authorization: "Bearer" + " " + state.token,
  //         },
  //       })
  //         .then(function (response) {
  //           alert(response);
  //         })
  //         .catch(function (error) {
  //           alert(error);
  //         });
  //     },
  //   []
  // );
  const dispatch = useDispatch();
  const allBookmarkFiles = useSelector(state => state.allBookmarkFiles);
  const { loading, error, fileDetails } = allBookmarkFiles;

  const currentWorkSpace = useSelector(state => state.currentWorkSpace);
  const { currentWorkspaceDetails } = currentWorkSpace;

  useEffect(() => {
    if (currentWorkspaceDetails) {
      dispatch(fetchBookmarkFiles(currentWorkspaceDetails._id))
    }
  }, [currentWorkspaceDetails])

  return (
    <div className="bookmarks">
      <div className="bookmark__header">
        <IconButton
          aria-label="close"
          onClick={(e) => {
            e.preventDefault();
            onSelfClose();
          }}
        >
          <CloseIcon style={{ color: "white" }} />
        </IconButton>
        <h3>Bookmarks</h3>
        {/* <IconButton
          onClick={(e) => {
            e.preventDefault();
            onSelfClose();
            onNotifyOpen();
          }}
        >
          {" "}
          <NotificationsNoneIcon
            style={{ color: "white" }}
          />
        </IconButton> */}
      </div>
      <div className='bookmarkContainer'>
        {error && <h4>{error}</h4>}
        {loading ? <CircularProgress /> : (
          fileDetails?.map(fileData => (
            <div className="bookmarks__container">
              <div className="single__bookmark">
                <div className="single__bookmark__header">
                  {/* <p
                  style={{
                    color: "#002173",
                    fontSize: "0.8rem",
                    marginBottom: "0.4rem",
                  }}
                >
                  {fileData.updated_at.substr(0, 10)}
                </p> */}
                  <div style={{ color: "#002273" }} className="single__bookmark__content">
                    <span className="single__bookmark__content__heading">File Name</span><br />
                    <span className="single__bookmark__content__info">{fileData.name}</span>
                  </div>
                  <div style={{ color: "#002273" }} className="single__bookmark__content">
                    <span className="single__bookmark__content__heading">Category</span><br />
                    <span className="single__bookmark__content__info">{fileData.type === 'LINKEDIN_ADD' ? "Linkedin Ad" : fileData.type === 'GOOGLE_ADD' ? "Google Ad" : fileData.type === 'TAGLINE' ? "Tagline" : fileData.type === 'BLOG_QUOTE' ? "Blog Quote" : "Caption"}</span>
                  </div>
                  <div style={{ color: "#002273" }} className="single__bookmark__content">
                    <span className="single__bookmark__content__heading">Date</span><br />
                    <span className="single__bookmark__content__info">{fileData.updated_at.substr(0, 10)}</span>
                  </div>
                </div>
                <div className="single__bookmark__container">
                  {fileData.results?.map(val => (
                    <div className="single__bookmark__container_div">
                      {val.content}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default Bookmarks;
